import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/prodotti', label: 'Prodotti' },
    { path: '/offerte', label: 'Offerte' },
    { path: '/azienda', label: 'Azienda' },
    { path: '/contatti', label: 'Contatti' },
    { path: '/media', label: 'Media' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center -ml-6">
            <img
              src="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg"
              alt="AGRO-INNOVAZIONI"
              className="h-20 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-[#2D5016]'
                    : 'text-gray-700 hover:text-[#2D5016]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center space-x-4">
            <button className="p-2 hover:bg-gray-100 rounded-full transition-colors cursor-pointer">
              <i className="ri-shopping-cart-line text-xl text-gray-700"></i>
            </button>
            <Link
              to="/prodotti"
              className="hidden md:block px-6 py-2.5 bg-[#2D5016] text-white rounded-full text-sm font-medium hover:bg-[#3d6b1e] transition-colors whitespace-nowrap cursor-pointer"
            >
              Shop Online
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
